import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LeadType } from "../api/models";
import { State } from "../store/interfaces";
import {
  loadTypeErrorAction,
  loadTypeRequestAction,
  loadTypeSuccessAction,
} from "../store/reducers/leadType";
import { StatusCodes } from "http-status-codes";
import { LeadTypeService } from "../api";

export const useLeadType = (leadTypeService: LeadTypeService) => {
  const intent = useSelector((state: State) => state.leadType);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadLeadType = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadTypeRequestAction());
    try {
      const response = await leadTypeService.loadAllLeadType();

      return dispatch(loadTypeSuccessAction(response));
    } catch (error) {
      return dispatch(loadTypeErrorAction());
    }
  };

  const createLeadType = async (data: LeadType, onSuccess?: () => void) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await leadTypeService.createLeadType({
        ...data,
        code: data.name?.trim()?.replace(/\s/g, "_"),
      });
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError(
        error?.response?.data?.message || "Unable to update details"
      );
    }
    setUpdating(false);
  };

  const updateLeadType = async (
    data: LeadType,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await leadTypeService.updateLeadType(data, id);
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError(
        error?.response?.data?.message || "Unable to update details"
      );
    }
    setUpdating(false);
  };

  return {
    loadLeadType,
    updateLeadType,
    updating,
    updateError,
    createLeadType,
  };
};
